// src/pages/Login.js
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authLogin } from "../api"; // api.js dagi authLogin
import { saveAuth } from "../auth";
import { ADMIN_BASE_PATH } from "../routes";
import "./Login.css";

export default function Login() {
  const [username, setUsername] = useState("");
  const [code, setCode] = useState(""); // PIN / kod (harf+raqam bo'lishi mumkin)
  const [loading, setLoading] = useState(false);

  const nav = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    const u = username.trim();
    const p = code.trim();
    if (!u || !p) {
      alert("Login va kod majburiy");
      return;
    }

    setLoading(true);
    try {
      // 1) PIN-login: /api/auth/login/ -> { access, refresh, user }
      const { access, refresh, user } = await authLogin(u, p);

      // 2) Auth ma'lumotlarini umumiy helper bilan saqlaymiz
      saveAuth({ access, refresh, user });

      // 3) Rolga qarab yo‘naltirish
      const redirectFrom = loc.state?.from?.pathname;

      if (redirectFrom) {
        nav(redirectFrom, { replace: true });
      } else {
        nav(ADMIN_BASE_PATH, { replace: true });
      }
    } catch (err) {
      const status = err?.response?.status;
      const data = err?.response?.data;
      console.error("LOGIN ERR", status, data);

      let msg = "Login xato. Username yoki kodni tekshiring.";
      if (data) {
        if (typeof data === "string") msg = data;
        else msg = JSON.stringify(data);
      } else if (err?.message) {
        msg = err.message;
      }

      alert(`Login xatosi (${status ?? "?"}): ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="login-form fr-panel" onSubmit={submit}>
        <h2>Kirish</h2>

        <input
          className="input"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
        />

        <input
          className="input"
          placeholder="Kod (PIN)"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          type="password"
        />

        <button className="btn btn-primary" disabled={loading} type="submit">
          {loading ? "Kirilmoqda..." : "Kirish"}
        </button>
      </form>
    </div>
  );
}
